module.exports = __webpack_public_path__ + "images/brooklyn-b8ec9767d76599795d90752916872da9.jpg";